import styled from 'styled-components';
import MuiCheckbox from '@material-ui/core/Checkbox';

export const StyledMuiCheckbox = styled(MuiCheckbox)`
  border-radius: 4px;
  padding: 5px;
  display: inline-flex;
  align-items: center;

  &:not(.disabled):hover {
    background: #E1E9FA;
    cursor: pointer;

    .MuiCheckbox-root {
      background: transparent ;

      .MuiIconButton-label {
        color: #26427C;
      }
    }
  }

  &.disabled {
    .CheckboxLabel {
      color: #525866 !important;
    }

    .MuiIconButton-label {
      color: #CFD6E5 !important;
    }
  }

  &.green {
    .MuiCheckbox-root {
      &.Mui-checked .MuiIconButton-label {
        color: #30BF78;
      }
    }

    &:hover {
      .MuiCheckbox-root {
        .MuiIconButton-label {
          color: #30BF78;
        }
      }
    }
  }

  .CheckboxLabel {
    margin-left: 5px;
    color: rgba(0,0,0,0.6);
  }

  .MuiCheckbox-root {
    padding: 0;

    .MuiIconButton-label {
      color: #CFD6E6;
    }

    &.Mui-checked .MuiIconButton-label {
      color: #26427C;
    }
  }

`;
